import { TreeOptions } from "@gtmhub/shared/tree-renderer/tree-models";
import { TreeRenderer } from "@gtmhub/shared/tree-renderer/tree-renderer";
import OrganizationTreeNode from "./organization-tree-node";

export class OrganizationTreeRenderer extends TreeRenderer {
  protected treeNodeClass = OrganizationTreeNode;

  constructor(protected treeContainer: HTMLElement) {
    super(treeContainer);
    super.setOptions({ showRoot: false });
  }

  /**
   * setOptions
   * Sets the Organization Tree configuration, ignoring the currently unaccepatable "showRoot" option.
   *
   * @param options
   * @returns {this}
   */
  public setOptions(options: TreeOptions): TreeRenderer {
    // currently, the Organization Tree is not meant to have a "root" (the company name, or the supreme leader, or something else),
    // so we explicitly disable it, not to break the design.
    return super.setOptions({
      ...options,
      showRoot: false,
    });
  }
}
